
import { Routes, Route } from 'react-router-dom'
import AuthGuard from '@/components/AuthGuard'
import AdminAuthGuard from '@/components/AdminAuthGuard'
import OperatorAuthGuard from '@/components/OperatorAuthGuard'
import Index from '@/pages/Index'
import Dashboard from '@/pages/Dashboard'
import Learn from '@/pages/Learn'
import ModuleDetail from '@/pages/ModuleDetail'
import Tasks from '@/pages/Tasks'
import Resources from '@/pages/Resources'
import Rewards from '@/pages/Rewards'
import Settings from '@/pages/Settings'
import AdminLogin from '@/pages/AdminLogin'
import AdminDashboard from '@/pages/AdminDashboard'
import OperatorLogin from '@/pages/OperatorLogin'
import OperatorDashboard from '@/pages/OperatorDashboard'
import NotFound from '@/pages/NotFound'
import Login from '@/pages/auth/Login'
import Signup from '@/pages/auth/Signup'
import Confirm from '@/pages/auth/Confirm'
import ResetPassword from '@/pages/auth/ResetPassword'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import PaymentInfo from '@/pages/auth/PaymentInfo'
import PaymentSuccess from '@/pages/auth/PaymentSuccess'
import Welcome from '@/pages/Welcome'
import ProtectedRoute from './ProtectedRoute'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/operator/login" element={<OperatorLogin />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth">
        <Route path="confirm" element={<Confirm />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="payment-info" element={<PaymentInfo />} />
        <Route path="payment-success" element={<PaymentSuccess />} />
      </Route>
      
      {/* Protected routes */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/learn" element={<ProtectedRoute><Learn /></ProtectedRoute>} />
      <Route path="/learn/module/:moduleId" element={<ProtectedRoute><ModuleDetail /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
      <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
      <Route path="/rewards" element={<ProtectedRoute><Rewards /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      
      {/* Admin routes */}
      <Route path="/admin/dashboard" element={<AdminAuthGuard><AdminDashboard /></AdminAuthGuard>} />
      
      {/* Operator routes */}
      <Route path="/operator/dashboard" element={<OperatorAuthGuard><OperatorDashboard /></OperatorAuthGuard>} />
      
      {/* 404 page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
